import consumer from '@/channels/consumer'
import { vuexConverter } from '@/utilities/vuex'

import { PARTY_NAMESPACE } from '../party'

const { mapAction } = vuexConverter(PARTY_NAMESPACE)

export const CHANNEL_NAMESPACE = 'PartyEditChannel'

export const PartyEditChannelActions = {
  UPDATED_PARTY: mapAction('peOnServerPartyUpdate'),
  UPDATED_CHARACTERISTIC: mapAction('peOnServerCharacteristicUpdate'),
}

export function PartyEditChannelPlugin (store) {
  consumer.subscriptions.create(CHANNEL_NAMESPACE, {
    received (command) {
      const { action, params } = command
      const storeAction = PartyEditChannelActions[action]

      if (!storeAction) return

      store.dispatch(storeAction, params)
    },
  })
}

export const SubscribeToThisPartyChangesChannel = (partyId, onUpdate) => {
  return consumer.subscriptions.create(
    { channel: 'PartyEditChannel', party_id: partyId },
    {
      received (command) {
        return onUpdate(command)
      },

    })
}
